import React from 'react';
import { createBrowserHistory } from 'history';
import replace from 'lodash/replace';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import CacheProvider from 'react-inlinesvg/provider';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Constants, ModelManager } from '@adobe/aem-spa-page-model-manager';
import { DEFAULT_LOCALE, TranslationProvider } from '@yme/services/i18n';
import { setDefaultPixelData } from '@yme/utils/bloomreach/helpers';
import { getBrData } from '@yme/utils/bloomreach/pixel';
import { adobeLaunch } from '@yme/utils/common';
import App from './App';
import { GlobalStyles } from './GlobalStyled';
import LocalDevModelClient from './LocalDevModelClient';
import ProductionModelClient from './ProductionModelClient';
import { PRELOAD_AEM_MODEL_EVENT } from './components/Link/constants';
import { store } from './store';
import { preloadPath } from './utils/preloader';
import { setDefaultOptionsDateFns } from './utils/setDefaultOptionsDateFns';
import './index.css';
import './components/import-components';
document.body.addEventListener(PRELOAD_AEM_MODEL_EVENT, preloadPath);
const { PATH_PROP, CHILDREN_PROP, ITEMS_PROP, ITEMS_ORDER_PROP } = Constants;
const isProxyEnabled = process?.env?.REACT_APP_PROXY_ENABLED;
const modelClient = isProxyEnabled
    ? new LocalDevModelClient(process.env.REACT_APP_API_HOST)
    : new ProductionModelClient();
const modelManagerOptions = {
    modelClient,
};
ModelManager.initialize(modelManagerOptions).then(async (value) => {
    const history = createBrowserHistory();
    const pageModel = value;
    const cqPath = pageModel[PATH_PROP] ?? '';
    const cqChildren = pageModel[CHILDREN_PROP];
    const cqItems = pageModel[ITEMS_PROP];
    const cqItemsOrder = pageModel[ITEMS_ORDER_PROP];
    const locale = replace(pageModel.language || DEFAULT_LOCALE, '-', '');
    const { language = DEFAULT_LOCALE } = new Intl.Locale(pageModel.language || DEFAULT_LOCALE);
    await setDefaultOptionsDateFns(locale);
    const { labels, isInAuthor, commercetoolsProjectKey, externalCart, languageRootPath, dealerLocatorPageUrl, bloomreachModel, searchResultsPageUrl, locationMismatchModalModel, configuratorLeadFormPagePath, financeCalculatorLeadFormPagePath, isKioskVersion, ecommerceEnabled, isoCountryCode = '', isInstallmentEnabled, isCycleSchemeEnabled, isOmnibusRegulationEnabled, } = pageModel;
    const br_data = getBrData();
    // Global tracking parameters
    setDefaultPixelData(br_data, bloomreachModel?.accountId, bloomreachModel?.productCatalog);
    return render(
    // @ts-expect-error undefined is not allowed
    React.createElement(CacheProvider, null,
        React.createElement(Provider, { store: store },
            React.createElement(BrowserRouter, null,
                React.createElement(React.StrictMode, null,
                    React.createElement(GlobalStyles, null),
                    React.createElement(TranslationProvider, { language: language },
                        React.createElement(HelmetProvider, null,
                            React.createElement(App
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            , { 
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                history: history, labels: labels, isInAuthor: isInAuthor, commercetoolsProjectKey: commercetoolsProjectKey, externalCart: externalCart, languageRootPath: languageRootPath, 
                                // cq props for AEM
                                cqPath: cqPath, cqChildren: cqChildren, cqItems: cqItems, cqItemsOrder: cqItemsOrder, 
                                // Extra props
                                dealerLocatorPageUrl: dealerLocatorPageUrl, locationPathname: window.location.pathname, locale: pageModel.language || DEFAULT_LOCALE, isoCountryCode: isoCountryCode, ecommerceEnabled: ecommerceEnabled, isInstallmentEnabled: isInstallmentEnabled, isCycleSchemeEnabled: isCycleSchemeEnabled, isKioskVersion: isKioskVersion, isOmnibusRegulationEnabled: isOmnibusRegulationEnabled, locationMismatchModalModel: locationMismatchModalModel, configuratorLeadFormPagePath: configuratorLeadFormPagePath, financeCalculatorLeadFormPagePath: financeCalculatorLeadFormPagePath, bloomreachModel: bloomreachModel, searchResultsPageUrl: searchResultsPageUrl }))))))), document.getElementById('spa-root'));
});
setTimeout(() => {
    /**
     * delay for 3 seconds to load adobe launch, to avoid blocking the main thread and initial render
     * we have events queued up in the data layer, so we can safely load the script after the initial render
     */
    adobeLaunch.loadScript();
}, 3000);
